import { HttpErrorResponse } from "@angular/common/http";

// interfaces
import { IhttpError } from 'src/app/core/interfaces/http-response/http-error';

/**
 * IHttpErrorResponse
 */
export interface IHttpErrorResponse extends HttpErrorResponse {
    error: IhttpError
}

export class HttpErrorResponseHandler extends HttpErrorResponse {
    
    /**
     * fields
     */
    private _htmlError: string = null;


    /**
     * 
     * @param _err 
     */
    constructor(private _err: IHttpErrorResponse) {
        /**
         * handler Error
         */
        if (_err == null) throw new Error(`arg _err is ${_err}`);

        // init
        super(_err);
        this.htmlErrorHandler();

    };

    /** Getter & Setters */

    /**
     * customError
     */
    public get customError(): IHttpErrorResponse {
        return this
    }

    /**
     * customError
     */
    public get htmlError(): string {
        return this._htmlError
    } 
    private set htmlError(err: string) {
        this._htmlError = err
    }        

    /** Methods */

    /**
     * htmlErrorHandler
     */
    private htmlErrorHandler(): void {

        const html = this.customError
                        .error
                        .errors
                        .map(err => err.msg)
                        .join(' <br/> ');

        this.htmlError = html;

    }


}
